import React, { useState, useEffect } from 'react';

// Inline SVG fallbacks — no external dependencies, no sample photos.
// Each fallback stays consistent even when third-party image hosts fail.
const mkSvg = (label, bg = '#f4f4f5', fg = '#9ca3af') => `data:image/svg+xml;utf8,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300' preserveAspectRatio='xMidYMid slice'>
    <rect width='400' height='300' fill='${bg}'/>
    <g fill='${fg}' font-family='system-ui,-apple-system,Segoe UI,Roboto,sans-serif' text-anchor='middle'>
      <circle cx='200' cy='125' r='38' fill='none' stroke='${fg}' stroke-width='6'/>
      <path d='M170 200 Q200 165 230 200' fill='none' stroke='${fg}' stroke-width='6' stroke-linecap='round'/>
      <text x='200' y='250' font-size='18' font-weight='600'>${label}</text>
    </g>
  </svg>`
)}`;

export const FALLBACK_IMAGES = {
  seller_profile: mkSvg('판매자', '#f5f5f7', '#c7c7cc'),
  seller_cover:   mkSvg('LIVEMOA', '#111827', '#4b5563'),
  broadcast:      mkSvg('LIVE 준비', '#fef2f2', '#fca5a5'),
  product:        mkSvg('상품 이미지', '#f4f4f5', '#a1a1aa'),
  avatar:         mkSvg('사용자', '#f5f5f7', '#c7c7cc'),
  generic:        mkSvg('이미지', '#f4f4f5', '#a1a1aa'),
};

const resolveUrl = (src) => {
  if (!src || typeof src !== 'string' || !src.trim()) return null;
  if (src.startsWith('/api/files/')) {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    return `${base}${src}`;
  }
  return src;
};

const SafeImg = ({ src, alt = '', kind = 'broadcast', className, loading = 'lazy', ...rest }) => {
  const fallback = FALLBACK_IMAGES[kind] || FALLBACK_IMAGES.generic;
  const [current, setCurrent] = useState(() => resolveUrl(src) || fallback);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const next = resolveUrl(src) || fallback;
    setCurrent(next);
    setFailed(false);
  }, [src, fallback]);

  return (
    <img
      src={current}
      alt={alt}
      loading={loading}
      onError={() => {
        if (!failed && current !== fallback) {
          setFailed(true);
          setCurrent(fallback);
        }
      }}
      className={className}
      {...rest}
    />
  );
};

export default SafeImg;
